import React from "react";
import { useFormattedMessage, useUtils } from "hooks";
import { PROJECT_STATUS } from "constants/status";
import { TENANTS_LIST, TENANTS_WITH_REGISTRATION_DISABLED } from "constants/index";
import {
    joinNowButtonText,
    login,
    purchaseOffersButtonText,
    salesOffersButtonText,
    pausedOffersButtonText,
    successfullyPaidBackButtonText,
    successfullyMarkedButtonText,
    investNowButtonText,
    makeNoteButtonText,
    successfullyCompletedButtonText,
    requestInformationClubButtonText,
    applyNowButtonText,
} from "i18n/messages/buttonTitles";
import { addOverlay } from "utils";
import { TradingOfferButton } from "./Buttons";
import NavLink from "components/NavLink";
import { useRouter } from "next/router";
import NewLoader from "components/NewLoader";

function ActionButtonsWithoutLogin(props) {
    const { status, projectOffers = [], setSecondaryMarketModalFlag } = props;
    const { formatMessage } = useFormattedMessage();
    const { tenant } = useUtils();

    switch (status) {
        //Refactored: isMarketplace
        case PROJECT_STATUS.MARKETPLACE:
            return (
                <div className="marketplace-buttons action-btn">
                    <TradingOfferButton
                        type="buy"
                        isShowActiveBtnClass={false}
                        value={projectOffers[0]?.sellPrice}
                        title={formatMessage(purchaseOffersButtonText)}
                        onClick={() => {
                            setSecondaryMarketModalFlag(true);
                            addOverlay();
                        }}
                    />
                    <TradingOfferButton
                        type="sell"
                        isShowActiveBtnClass={false}
                        value={projectOffers[0]?.highestBuyPrice}
                        title={formatMessage(salesOffersButtonText)}
                        onClick={() => {
                            setSecondaryMarketModalFlag(true);
                            addOverlay();
                        }}
                    />
                </div>
            );
        //Refactored: isMarketplacePaused
        case PROJECT_STATUS.MARKETPLACE_PAUSED:
            return (
                <button className="mb-0 action-btn disable-grey target-button">{formatMessage(pausedOffersButtonText)}</button>
            );
        //Refactored: isSuccessfullyPaidBack
        case PROJECT_STATUS.SUCCESSFULLY_PAID_BACK:
            return (
                <button className="mb-0 action-btn disable-grey target-button">
                    {formatMessage(successfullyPaidBackButtonText)}
                </button>
            );
        default:
            return tenant?.TechnicalName == TENANTS_LIST.WATCHVEST ? (
                <button className="mb-0 action-btn disable-grey target-button">{formatMessage(pausedOffersButtonText)}</button>
            ) : TENANTS_WITH_REGISTRATION_DISABLED.includes(tenant?.TechnicalName) ? (
                <NavLink className="w-100" href={"/login"}>
                    <button className="action-btn mb-0 target-button">{formatMessage(login)}</button>
                </NavLink>
            ) : (
                <NavLink className="w-100" href={"/register"}>
                    <button className="action-btn mb-0 target-button">{formatMessage(joinNowButtonText)}</button>
                </NavLink>
            );
    }
}

function ActionButtonsWithLogin(props) {
    const {
        status,
        isProjectInterested,
        projectOffers = [],
        setBuySharesModalFlag,
        setSecondaryMarketModalFlag,
        setSellSharesModalFlag,
        setPropertyInterestModalFlag,
        isUserInvestmentsLoading,
        isSingleProductLoading,
        VIPUser,
        isAllowSecondaryMarket,
        onInvestmentButtonClick,
        isUserFullyOnBoarded,
        isUserStatusEmailVerified,
        isUserTermsAndConditionsAccepted,
        isUserOnboardingNotCompleted,
    } = props;

    const { formatMessage } = useFormattedMessage();
    const { tenant } = useUtils();
    const router = useRouter();

    switch (status) {
        //1: Refactored: isMarketplace
        case PROJECT_STATUS.MARKETPLACE:
            return (
                <div className="marketplace-buttons action-btn">
                    <TradingOfferButton
                        type="buy"
                        isShowActiveBtnClass={false}
                        value={projectOffers[0]?.sellPrice}
                        title={formatMessage(purchaseOffersButtonText)}
                        onClick={() => {
                            if (!isUserFullyOnBoarded) {
                                if (!isUserStatusEmailVerified) router.push("/email-confirmation");
                                else if (isUserStatusEmailVerified) {
                                    if (isUserOnboardingNotCompleted) router.push("/user-onboarding");
                                    else if (!isUserTermsAndConditionsAccepted) router.push("/retail/accept-terms-conditions");
                                }
                            } else {
                                isAllowSecondaryMarket ? setBuySharesModalFlag(true) : setSecondaryMarketModalFlag(true);
                                addOverlay();
                            }
                        }}
                    />
                    <TradingOfferButton
                        type="sell"
                        isShowActiveBtnClass={false}
                        value={projectOffers[0]?.highestBuyPrice}
                        title={formatMessage(salesOffersButtonText)}
                        onClick={() => {
                            if (!isUserFullyOnBoarded) {
                                if (!isUserStatusEmailVerified) router.push("/email-confirmation");
                                else if (isUserStatusEmailVerified) {
                                    if (isUserOnboardingNotCompleted) router.push("/user-onboarding");
                                    else if (!isUserTermsAndConditionsAccepted) router.push("/retail/accept-terms-conditions");
                                }
                            } else {
                                isAllowSecondaryMarket ? setSellSharesModalFlag(true) : setSecondaryMarketModalFlag(true);
                                addOverlay();
                            }
                        }}
                    />
                </div>
            );
        //2: Refactored: canUserReserve
        case PROJECT_STATUS.ADVERTISING:
        case PROJECT_STATUS.CLUB_DEAL:
            return isProjectInterested ? (
                <button className="mb-0 action-btn interest-btn target-button green">
                    {formatMessage(successfullyMarkedButtonText)}
                </button>
            ) : (
                <button
                    className="action-btn interest-btn target-button"
                    onClick={async () => {
                        setPropertyInterestModalFlag(true);
                        addOverlay();
                    }}
                >
                    {formatMessage(makeNoteButtonText)}
                </button>
            );
        //3: Refactored: isMarketplacePaused
        case PROJECT_STATUS.MARKETPLACE_PAUSED:
            return (
                <button className="mb-0 action-btn disable-grey target-button">{formatMessage(pausedOffersButtonText)}</button>
            );
        //4: Refactored: isSuccessfullyPaidBack
        case PROJECT_STATUS.SUCCESSFULLY_PAID_BACK:
            return (
                <button className="mb-0 action-btn disable-grey target-button">
                    {formatMessage(successfullyPaidBackButtonText)}
                </button>
            );
        //5: Refactored: isFinancingCompleted || isFundingClosed
        case PROJECT_STATUS.FINANCING_COMPLETED:
        case PROJECT_STATUS.FUNDING_CLOSED:
            return (
                <button className="mb-0 action-btn disable-grey target-button">
                    {formatMessage(successfullyCompletedButtonText)}
                </button>
            );
        //6: Refactored: canUserInvest
        case PROJECT_STATUS.FUNDING_ACTIVE:
        case PROJECT_STATUS.VIP_FUNDING:
            if (PROJECT_STATUS.VIP_FUNDING == status && !VIPUser) {
                return isProjectInterested ? (
                    <button className="mb-0 action-btn interest-btn target-button green">
                        {formatMessage(successfullyMarkedButtonText)}
                    </button>
                ) : (
                    <button
                        className="action-btn interest-btn target-button"
                        onClick={async () => {
                            setPropertyInterestModalFlag(true);
                            addOverlay();
                        }}
                    >
                        {formatMessage(makeNoteButtonText)}
                    </button>
                );
            }

            return (
                <button
                    id="invest-now-button"
                    className={`invest-now-button action-btn mb-0 target-button ${
                        isUserInvestmentsLoading || isSingleProductLoading ? "pointer-none" : ""
                    }`}
                    onClick={() => {
                        if (!isUserFullyOnBoarded) {
                            if (!isUserStatusEmailVerified) router.push("/email-confirmation");
                            else if (isUserStatusEmailVerified) {
                                if (isUserOnboardingNotCompleted) router.push("/user-onboarding");
                                else if (!isUserTermsAndConditionsAccepted) router.push("/retail/accept-terms-conditions");
                            }
                        } else if (!isUserInvestmentsLoading || !isSingleProductLoading) onInvestmentButtonClick();
                    }}
                >
                    {isUserInvestmentsLoading || isSingleProductLoading ? <NewLoader /> : formatMessage(investNowButtonText)}
                </button>
            );
        case PROJECT_STATUS.PENDING_TOKEN:
            return null;
        //7: Default
        default:
            return tenant?.TechnicalName == TENANTS_LIST.WATCHVEST ? (
                <button className="mb-0 action-btn disable-grey target-button">{formatMessage(pausedOffersButtonText)}</button>
            ) : (
                <NavLink className="w-100" href={"/register"}>
                    <button className="action-btn mb-0 target-button">{formatMessage(joinNowButtonText)}</button>
                </NavLink>
            );
    }
}

function ClubDealButtonsWithLogin(props) {
    const { isTypeClubWithShare, status = "", setHideReserveSection, setPropertyInterestModalFlag } = props;

    const { formatMessage } = useFormattedMessage();
    const userCantInvest = status == PROJECT_STATUS.FUNDING_ACTIVE && !isTypeClubWithShare;

    //Refactored: checked these status only based on old code
    const clubDealUsefulStatus = {
        [PROJECT_STATUS.FUNDING_CLOSED]: true,
        [PROJECT_STATUS.FINANCING_COMPLETED]: true,
        [PROJECT_STATUS.MARKETPLACE_PAUSED]: true,
        [PROJECT_STATUS.MARKETPLACE]: true,
        [PROJECT_STATUS.FUNDING_ACTIVE]: true,
        [PROJECT_STATUS.SUCCESSFULLY_PAID_BACK]: true,
    };

    if (userCantInvest || !clubDealUsefulStatus[status]) {
        return (
            <button
                className="action-btn mb-0 target-button"
                onClick={() => {
                    setHideReserveSection(true);
                    setPropertyInterestModalFlag(true);
                    addOverlay();
                }}
            >
                {formatMessage(requestInformationClubButtonText)}
            </button>
        );
    } else {
        return <ActionButtonsWithLogin {...props} />;
    }
}

function ClubDealButtonsWithoutLogin(props) {
    const { status = "" } = props;
    const { formatMessage } = useFormattedMessage();

    //Refactored: checked these status only based on old code
    const clubDealUsefulStatus = {
        [PROJECT_STATUS.MARKETPLACE_PAUSED]: true,
        [PROJECT_STATUS.MARKETPLACE]: true,
    };

    if (clubDealUsefulStatus[status]) {
        return <ActionButtonsWithoutLogin {...props} />;
    } else {
        return (
            <NavLink isForcePushed href="/program/club-deal#registration">
                <button className="mb-0 action-btn target-button">{formatMessage(applyNowButtonText)}</button>
            </NavLink>
        );
    }
}

export { ActionButtonsWithoutLogin, ActionButtonsWithLogin, ClubDealButtonsWithLogin, ClubDealButtonsWithoutLogin };
